import React from "react";
import "./FixedBackgroundScrolling.scss";

const FixedBackgroundGrid: React.FC = () => {
  const services = [
    {
      title: "CROSS-BORDER SHIPPING",
      description:
        "Seamless, compliant transport between Canada and the U.S. - trusted by shippers for over 25 years.",
    },
    {
      title: "WAREHOUSE AND DISTRIBUTION",
      description:
        "100,000+ Sq. Ft. of Strategic, Food-Grade Certified Warehousing. Thousands of pallets tracked and handled daily using intelligent Warehouse Management System (WMS) technology.",
    },
    {
      title: "TRADESHOW LOGISTICS",
      description:
        "From LTL to full truckload or expedited, we offer complete end-to-end logistics, including advance warehouse services, move-in/move-out coordination, and onsite representation.",
    },
    {
      title: "EXPEDITE BY SPRINTER & CARGO VANS",
      description:
        "For urgent loads, small shipments, or last-minute deliveries - our dedicated expedite team offers speed, tracking, and peace of mind.",
    },
    {
      title: "WE MOVE ALL TYPES OF FREIGHT",
      description:
        "From dry and temperature-controlled to hazardous and over-dimensional freight, we have the expertise and resources to move it safely and efficiently.",
    },
    {
      title: "Smart Freight Dashboard",
      description:
        "Manage your shipments, track deliveries in real time, update your account, and chat with our team - all in one easy-to-use online platform.",
    },
  ];

  return (
    <section className="grid-container">
      <div className="fixed-background" />
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-tile">
            <div className="tile-content">
              <h3 data-text={service.title}>{service.title}</h3>
              <p>{service.description}</p>
              {/* <button className="learn-more-btn">
                <span>Learn More</span>
              </button> */}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FixedBackgroundGrid;
